import { useState, useEffect, useContext, useCallback } from "react";
import { IconButton, Button, Backdrop, CircularProgress } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { API, PAGE_SIZE, CSV_ANIMALQUAR, MSG } from "./constantsFront";
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import _ from 'lodash';
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import { CSVLink } from "react-csv";
import { useDropzone } from "react-dropzone";
import moment from "moment";
import { MsgContext } from "../../App";
import CSVReader from 'react-csv-reader'
import { useRef } from "react";

/**
 * 動物検疫一覧
 * @returns 
 */


const G0141AnimalQuarantineList = () => {
  const [rows, setRows] = useState([]); // 表示データ
  const [quarList, setQuarList] = useState(""); //　動物検疫一覧
  const [contryList, setContryList] = useState(""); // 国名一覧
  const [pageSize, setPageSize] = useState(PAGE_SIZE);// ページサイズ
  const { msg, setMsg } = useContext(MsgContext); // エラーメッセージ


  const [selectProductCode, setSelectProductCode] = useState(""); // 選択品目コード

  const [alliesOpen, setAlliesOpen] = useState(false); // 品目同類ダイアログ
  const [alliesRows, setAlliesRows] = useState([]); // 品目同類
  const [alliesDummyId, setAlliesDummyId] = useState(0); // 品目同類ダミーID
  const [alliesDeleteId, setAlliesDeleteId] = useState([]); // 品目同類削除ID

  const [analogyOpen, setAnalogyOpen] = useState(false); // 品目類推ダイアログ
  const [analogyRows, setAnalogyRows] = useState([]); // 品目類推
  const [analogyDummyId, setAnalogyDummyId] = useState(0); // 品目類推ダミーID
  const [analogyDeleteId, setAnalogyDeleteId] = useState([]); // 品目類推削除ID

  const [selectedFile, setSelectedFile] = useState(); // 選択したファイル
  const [fileData, setFileData] = useState(); // 選択したファイルデータ
  const [csvErrorMsg, setCsvErrorMsg] = useState([]); // CSVアップロードエラーメッセージ

  const [ExportLicenseList, setExportLicenseList] = useState([]); // 輸出可否マスタ取得

  const [isLoading, setIsLoading] = useState(false);  // Loading

  const navigate = useNavigate();

  let body = { authKey: API.API_KEY };

  // CSVヘッダ
  const csvHeader = [
    { label: "輸出相手国", key: "country_name" },
    { label: "品目", key: "product_code" },
    { label: "動物衛生・食品衛生_輸出可否", key: "exportability_code" },
    { label: "動物衛生・食品衛生_補足文言", key: "supplement" },
    { label: "動物衛生・食品衛生_注釈", key: "special_cond" },
    { label: "動物衛生・食品衛生_関連URL", key: "url" },
    { label: "漁獲証明書_輸出可否", key: "marine_exportability_code" },
    { label: "漁獲証明書_補足文言", key: "marine_supplement" },
    { label: "漁獲証明書_注釈", key: "marine_special_cond" },
    { label: "漁獲証明書_関連URL", key: "marine_url" },
    { label: "有効日", key: "enable_date" },
    { label: "無効となる日", key: "disable_date" },
  ];

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    displayData();

    // 輸出可否マスタ取得
    axios.post("/m_export_license/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }
      setExportLicenseList(res.data.dataList);
    });

    // 国同類マスタ取得
    // body.isMaster = 1;
    const res2 = axios.post("/m_synonym_country/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      setContryList(res.data.dataList);
    });

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  // 表示データ用
  function displayData() {
    // Loading
    setIsLoading(true);
    // 動物検疫一覧取得
    body = { authKey: API.API_KEY };
    axios.post("/m_animal_quar/select/admin/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      // 日付をフォーマット
      let quarList = res.data.quarList.map(row => (
        {
          ...row,
          enable_date: moment(row.enable_date).format("YYYY/MM/DD"),
          disable_date: row.disable_date != null ? moment(row.disable_date).format("YYYY/MM/DD") : ""
        }));

      setQuarList(quarList);

      // 表示データ
      let rows = [];
      for (let i in quarList) {
        let displayNA = "";
        if (quarList[i].country_name == "NA") {
          displayNA = "none";
        }
        rows.push({
          id: i
          , country_code: quarList[i].country_code
          , country_name: quarList[i].country_name
          , product_code: quarList[i].product_code
          , enable_date: quarList[i].enable_date
          , disable_date: quarList[i].disable_date
          , displayNA: displayNA
        });
      }
      setRows(rows);
    }).catch(error => {
      console.log('error:', error);
      setMsg(MSG.EXCEPTION);
    }).finally(() => {
      // Loading
      setIsLoading(false);
    });
  }

  // ヘッダー
  const columns = [
    // { field: 'country_code', headerName: '輸出相手国コード', width: 170 },
    { field: 'country_name', headerName: '輸出相手国名', width: 200 },
    { field: 'product_code', headerName: '品目コード', width: 200 },
    // { field: 'packing_name', headerName: '梱包方法', width: 130 },
    { field: 'enable_date', headerName: '有効日', width: 100 },
    { field: 'disable_date', headerName: '無効日', width: 100 },
    {
      field: 'edit', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) => <Link to={"/G0142AnimalQuarantineEdit"}
        state={{
          ID: params.row.id
          , CountryCode: params.row.country_code
          , CountryName: params.row.country_name
          , ProductCode: params.row.product_code
          , EnableDate: params.row.enable_date
        }}>
        <Tooltip title="編集" arrow><IconButton ><EditIcon /></IconButton></Tooltip></Link>
    },
    {
      field: 'delete', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) =>
        <Tooltip style={{ display: params.row.displayNA }} title="削除" arrow>
          <IconButton
            onClick={() => deleteAnimalQuar(
              params.row.country_code
              , params.row.product_code
              , params.row.enable_date
              , params.row.enable_date
            )}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
    },
    {
      field: "allies", headerName: "", sortable: false, disableClickEventBubbling: true, width: 100,
      renderCell: (params) =>
        <Button style={{ display: params.row.displayNA }}
          onClick={() => handleClickOpenAllies(params.row.product_code)}>
          同類
        </Button>
    },
    {
      field: "analogy", headerName: "", sortable: false, disableClickEventBubbling: true, width: 100,
      renderCell: (params) =>
        <Button style={{ display: params.row.displayNA }}
          onClick={() => handleClickOpenAnalogy(params.row.product_code)}>
          類推
        </Button>
    },
  ];

  // 同類ボタンヘッダー
  const alliesColumns = [
    { field: "product_code", headerName: "品目コード", width: 200 },
    { field: "product_name", headerName: "品目名", width: 300, editable: true },
    {
      field: "delete", headerName: "", sortable: false, disableClickEventBubbling: true, width: 100,
      renderCell: (params) => <Tooltip title="削除" arrow><IconButton onClick={() => deleteAllies(params.id)}><DeleteIcon /></IconButton></Tooltip>
    },
  ];

  // 類推ボタンヘッダー
  const analogyColumns = [
    { field: "product_code", headerName: "品目コード", width: 200 },
    { field: "product_name", headerName: "品目名", width: 300, editable: true },
    {
      field: "delete", headerName: "", sortable: false, disableClickEventBubbling: true, width: 100,
      renderCell: (params) => <Tooltip title="削除" arrow><IconButton onClick={() => deleteAnalogy(params.id)}><DeleteIcon /></IconButton></Tooltip>
    },
  ];

  // 削除ボタン処理
  async function deleteAnimalQuar(select_country_code, select_product_code, select_enable_date) {
    try {
      if (window.confirm('削除してもよろしいですか？')) {
        console.log('削除処理開始');
        body.SelectCountryCode = select_country_code;
        body.SelectProductCode = select_product_code;
        body.SelectEnableDate = select_enable_date;
        const res = await axios.post("/m_animal_quar/select/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }

        // 同じ品目コードが何件あるか
        if (res.data.dataList.length == 1) {
          body.unregistered = true;
        } else {
          body.unregistered = false;
        }

        const res2 = await axios.post("/m_animal_quar/delete/auth", body);
        // 取得チェック
        if (res2.status != 200) {
          return;
        }

        return displayData();
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。1");
    }
  }

  // ダイアログ表示（同類）
  async function handleClickOpenAllies(productCode) {
    try {
      setAlliesOpen(true);

      // 品目同類一覧取得
      if (!productCode) {
        throw "";
      }

      setSelectProductCode(productCode);
      body.productCode = productCode;
      body.quarType = 2;
      const res = await axios.post("/m_synonym_product/select/admin/auth", body);
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      let alliesList = res.data.dataList;
      let rowsData = [];
      let alliesDummyId;
      for (let i in alliesList) {
        rowsData.push({
          id: i
          , product_code: productCode
          , product_name: alliesList[i].product_name
        });
        alliesDummyId = i;
      }
      setAlliesRows(rowsData);
      setAlliesDummyId(alliesDummyId);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // 新規追加（同類）
  function setAlliesEmpty() {
    // 配列の最後を取得するようにする
    let alliesId = 0;
    if (typeof alliesDummyId !== "undefined") {
      alliesId = Number(alliesDummyId) + 1;
    }
    setAlliesRows([{ id: alliesId, product_code: selectProductCode, product_name: null }, ...alliesRows]);
    setAlliesDummyId(alliesId);
  }

  // 変更時（同類）
  function editAlliesChange(v) {
    // 変更した後に削除した配列をフィルタ
    let arr = Object.keys(v);
    if (arr.length != 0) {
      let cloneRows = _.cloneDeep(alliesRows);
      let id = Number(arr[0]);
      let key = Object.keys(v[id]);
      let value = v[id][key].value;

      let idx = alliesRows.findIndex(d => d.id == id);
      cloneRows[idx][key] = value;
      setAlliesRows(cloneRows);
    }
  }

  // 保存ボタン（同類）
  async function alliesDecisionButton() {
    try {
      if (window.confirm("保存してもよろしいですか？")) {
        let uniqueList = [];
        for (let i in alliesRows) {
          console.log(alliesRows[i])
          if (!(alliesRows[i].product_name)) {
            return setMsg("未入力の項目が存在します。");
          }
          if(alliesRows[i].product_name == alliesRows[i].product_code){
            return setMsg("品目コードと品目名が一致する項目が存在します。");
          }
          let unique = alliesRows[i].product_name.trim()
          if (uniqueList.indexOf(unique) != -1) {
            return setMsg("名称が重複しています:"+unique);
          }
          uniqueList.push(unique);
        }

        const res = await axios.post("/m_synonym_product/max_synonym_id/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }

        // 同類IDの最大値を取得
        let synonymId = 0;
        if (res.data.dataList.length != 0) {
          synonymId = Number(res.data.dataList[0].synonym_id) + 1;
        }

        let arrStr = JSON.stringify(alliesRows);
        // 検索
        body.arrStr = arrStr;
        body.synonymId = synonymId;
        body.productCode = selectProductCode;
        body.quarType = 2;

        const res2 = await axios.post("/m_synonym_product/replacement/auth", body);
        // 取得チェック
        if (res2.status != 200) {
          return;
        }
        setAlliesOpen(false);
        setAlliesRows([]);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // キャンセルボタン（同類）
  function alliesCancelButton() {
    if (window.confirm("修正内容をキャンセルします。宜しいですか？")) {
      setAlliesOpen(false);
      setAlliesRows([]);
    }
  };

  // 削除（同類）
  function deleteAllies(id) {
    let cloneRows = _.cloneDeep(alliesRows);
    for (let i in cloneRows) {
      if (cloneRows[i].id == id) {
        setAlliesDeleteId([...alliesDeleteId, String(id)]);
        cloneRows.splice(i, 1);
        return setAlliesRows(cloneRows);
      }
    }
  }

  // ダイアログ表示（類推）
  async function handleClickOpenAnalogy(productCode) {
    try {
      setAnalogyOpen(true);

      // 品目同類一覧取得
      if (!productCode) {
        throw "";
      }

      setSelectProductCode(productCode);
      body.productCode = productCode;
      body.quarType = 2;
      const res = await axios.post("/m_analogy_product/select/auth", body);
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      let analogyList = res.data.dataList;
      let rowsData = [];
      let analogyDummyId;
      for (let i in analogyList) {
        rowsData.push({
          id: i
          , product_code: productCode
          , product_name: analogyList[i].product_name
        });
        analogyDummyId = i;
      }
      setAnalogyRows(rowsData);
      setAnalogyDummyId(analogyDummyId);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // 新規追加（類推）
  function setAnalogyEmpty() {
    // 配列の最後を取得するようにする
    let analogyId = 0;
    if (typeof analogyDummyId !== "undefined") {
      analogyId = Number(analogyDummyId) + 1;
    }
    setAnalogyRows([{ id: analogyId, product_code: selectProductCode, product_name: null }, ...analogyRows]);
    setAnalogyDummyId(analogyId);
  }

  // 変更時（類推）
  function editAnalogyChange(v) {
    // 変更した後に削除した配列をフィルタ
    let arr = Object.keys(v);
    if (arr.length != 0) {
      let cloneRows = _.cloneDeep(analogyRows);
      let id = Number(arr[0]);
      let key = Object.keys(v[id]);
      let value = v[id][key].value;

      let idx = analogyRows.findIndex(d => d.id == id);
      cloneRows[idx][key] = value;
      setAnalogyRows(cloneRows);
    }
  }

  // 保存ボタン（類推）
  async function analogyDecisionButton() {
    try {
      if (window.confirm("保存してもよろしいですか？")) {
        let uniqueList = [];
        for (let i in analogyRows) {
          console.log(analogyRows[i])
          if (!(analogyRows[i].product_name)) {
            return setMsg("未入力の項目が存在します。");
          }
          if(analogyRows[i].product_name == analogyRows[i].product_code){
            return setMsg("品目コードと品目名が一致する項目が存在します。");
          }
          let unique = analogyRows[i].product_name.trim()
          if (uniqueList.indexOf(unique) != -1) {
            return setMsg("名称が重複しています:"+unique);
          }
          uniqueList.push(unique);
        }

        const res = await axios.post("/m_analogy_product/max_analogy_id/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }

        // 類推IDの最大値を取得
        let analogyId = 0;
        console.log(res.data.dataList);
        if (res.data.dataList.length != 0) {
          analogyId = Number(res.data.dataList[0].analogy_id) + 1;
        }

        console.log(analogyRows);

        let arrStr = JSON.stringify(analogyRows);
        // 検索
        body.arrStr = arrStr;
        body.analogyId = analogyId;
        body.productCode = selectProductCode;
        body.quarType = 2;

        console.log(body);
        const res2 = await axios.post("/m_analogy_product/replacement/auth", body);
        // 取得チェック
        if (res2.status != 200) {
          return;
        }
        setAnalogyOpen(false);
        setAnalogyRows([]);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // キャンセルボタン（類推）
  function analogyCancelButton() {
    if (window.confirm("修正内容をキャンセルします。宜しいですか？")) {
      setAnalogyOpen(false);
      setAnalogyRows([]);
    }
  };

  // 削除（類推）
  function deleteAnalogy(id) {
    let cloneRows = _.cloneDeep(analogyRows);
    for (let i in cloneRows) {
      if (cloneRows[i].id == id) {
        setAnalogyDeleteId([...analogyDeleteId, String(id)]);
        cloneRows.splice(i, 1);
        return setAnalogyRows(cloneRows);
      }
    }
  }

  // CSVファイルを選択時trueを設定
  const changeHandlerCsv = (event) => {
    setSelectedFile(event.target.files[0]);
    event.target.value = '';
  };

  // ファイル選択ボタン
  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFile(acceptedFiles[0]);
  }, []);
  const { open, acceptedFiles } = useDropzone({
    accept: {
      'text/csv': [],
    },
    multiple: false,
    onDrop,
    noClick: true
  });

  // CSVアップロードボタン
  async function handleFiles() {
    try {
      // Loading
      setIsLoading(true);
      // 再レンダリング用スリープ  
      await new Promise(r => setTimeout(r, 100));

      setFileData();
      setSelectedFile();
      setCsvErrorMsg([]);
      if (!selectedFile) {
        return setMsg("ファイルを選択してください");
      }

      // 輸出可否コードリスト
      let expCodeList = [];
      for (let i in ExportLicenseList) {
        expCodeList.push(ExportLicenseList[i].exportability_code);
      }

      let csletr = [];
      // 重複チェック用
      let uniqueList = [];

      // NA存在チェックフラグ
      let NAFlag = 0;

      console.log(fileData)

      // 1行ごとに処理
      for (let i in fileData) {
        let cells = fileData[i];
        //現在の行数
        let row = Number(i) + 1;

        // 必須チェックエラーカウント
        let csvError = 0;

        //CSVの中身が正しい場合
        console.log(cells)
        if (cells.length == 1 && cells[0] == "") {
          uniqueList.push([]);
          continue;
        } else if (cells.length == 12) {
          csletr.push(cells);

          // 必須チェック開始
          if (csletr[i][CSV_ANIMALQUAR.COUNTRY_NAME] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : 輸出相手国は必須です。");
          }

          if (csletr[i][CSV_ANIMALQUAR.PRODUCT_CODE] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : 品目は必須です。");
          }

          if (csletr[i][CSV_ANIMALQUAR.EX_CODE] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : 動物衛生・食品衛生_輸出可否は必須です。");
          } else {
            if (expCodeList.indexOf(csletr[i][CSV_ANIMALQUAR.EX_CODE]) == -1 && i != 0) {
              csvError++;
              csvErrorMsg.push(row + "行目 : 動物衛生・食品衛生_輸出可否文字が不正です。");
            }
          }

          if (csletr[i][CSV_ANIMALQUAR.MARINE_EX_CODE] == '') {

          } else {
            if (expCodeList.indexOf(csletr[i][CSV_ANIMALQUAR.MARINE_EX_CODE]) == -1 && i != 0) {
              csvError++;
              csvErrorMsg.push(row + "行目 : 漁獲証明書_輸出可否文字が不正です。");
            }
          }

          if (csletr[i][CSV_ANIMALQUAR.ENABLE_DATE] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : 有効日は必須です。");
          }

          // //同じデータが存在する場合
          // let unique = "輸出相手国" + csletr[i][CSV_ANIMALQUAR.COUNTRY_NAME]
          //   + "品目" + csletr[i][CSV_ANIMALQUAR.PRODUCT_CODE]
          //   + "有効日" + csletr[i][CSV_ANIMALQUAR.ENABLE_DATE];
          // if (uniqueList.indexOf(unique) != -1) {
          //   csvError++;
          //   csvErrorMsg.push((uniqueList.indexOf(unique) + 1) + "行目と同じデータが" + row + "行目に存在します。");
          // }
          // uniqueList.push(unique);

          if (csvError > 0) {
            return setMsg(csvErrorMsg.join('<br />'));
          }
          // 必須チェック終了

          if (csletr[i][CSV_ANIMALQUAR.DISABLE_DATE] == "") {
            csletr[i][CSV_ANIMALQUAR.DISABLE_DATE] = null;
          }

          // 地域コード存在チェックフラグ
          let countryFlag = 0;

          if (i != 0) {
            if (csletr[i][CSV_ANIMALQUAR.COUNTRY_NAME] != "NA") {
              // 国同類マスタから地域コードを取得する
              for (let j in contryList) {
                if (csletr[i][CSV_ANIMALQUAR.COUNTRY_NAME] == contryList[j].country_name) {
                  csletr[i][CSV_ANIMALQUAR.COUNTRY_CODE] = contryList[j].country_code;
                  countryFlag = 1;
                  break;
                }
              }

              if (countryFlag == 0) {
                console.log(csletr[i][CSV_ANIMALQUAR.COUNTRY_NAME]);
                return setMsg(row + "行目 : 輸出相手国が未登録です。");
              }
            } else {
              csletr[i][CSV_ANIMALQUAR.COUNTRY_CODE] = "NA";
              NAFlag = 1;
            }
          }
          //同じデータが存在する場合、エラー表示
          let unique = "輸出相手国" + csletr[i][CSV_ANIMALQUAR.COUNTRY_CODE]
            + "品目" + csletr[i][CSV_ANIMALQUAR.PRODUCT_CODE]
            + "有効日" + csletr[i][CSV_ANIMALQUAR.ENABLE_DATE];
          if (uniqueList.indexOf(unique) != -1) {
            csvError++;
            csvErrorMsg.push((uniqueList.indexOf(unique) + 1) + "行目と同じデータが" + row + "行目に存在します。");
            return setMsg(csvErrorMsg.join('<br />'));
          }
          uniqueList.push(unique);


        } else {
          return setMsg("CSVの項目数が違うため取り込みを中止しました。");
        }
      }

      if (NAFlag == 0) {
        return setMsg("NAデータが存在しないため取り込みを中止しました。");
      }

      console.log("CSVのチェックが終わりました。");

      const maxid = await axios.post("/m_synonym_product/max_synonym_id/auth", body);
      // 取得チェック
      if (maxid.status != 200) {
        return;
      }

      // 同類IDの最大値を取得
      let synonymId = 0;
      if (maxid.data.dataList.length != 0) {
        synonymId = Number(maxid.data.dataList[0].synonym_id) + 1;
      }

      let arrStr = JSON.stringify(csletr);
      body.arrStr = arrStr

      body.synonymId = synonymId;

      console.log(body.arrStr);

      // 登録処理
      await axios.post("/m_animal_quar/upload/auth", body);
      displayData();
      alert("アップロードに成功しました。");
    } catch (err) {
      setMsg("登録に失敗しました。");
      return;
    } finally {
      // 有効フラグ処理
      await axios.post("/m_animal_quar/enable_change");
      setIsLoading(false);
    }
  }

  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: header =>
      header
        .toLowerCase()
        .replace(/\W/g, '_')
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" >
                {/* Loading */}
                <Backdrop open={isLoading}
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                  <CircularProgress />
                </Backdrop>

                <Stack spacing={2}>
                  <h1>動物衛生・食品衛生／漁獲証明書</h1>

                  <Stack spacing={2} direction="row">
                    <Button component={Link} to={"/G0142AnimalQuarantineEdit"}
                      state={{ ID: -1 }}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      新規追加
                    </Button>

                    <CSVLink style={{ color: "white", textDecoration: "none" }}
                      filename={"動物衛生・食品衛生_漁獲証明書.csv"} headers={csvHeader} data={quarList}>
                      <Button
                        style={{ width: "200px" }}>CSVダウンロード
                      </Button>
                    </CSVLink>
                  </Stack>

                  <Stack spacing={2} direction="row">
                    <Button style={{ width: "200px" }} letiant="contained" component="label" onChange={changeHandlerCsv}>
                      CSVファイルを選択
                      <CSVReader
                        inputStyle={{ display: "none" }}
                        onFileLoaded={(data, fileInfo, originalFile) => setFileData(data)}
                      />
                    </Button>

                    {selectedFile != null ? (
                      <>
                        <div>
                          <p>ファイル名: {selectedFile.name}</p>
                        </div>
                        <Button
                          style={{ width: "200px" }}
                          onClick={handleFiles}
                        >
                          登録実行
                        </Button>
                      </>
                    ) : (
                      <div><p>CSVファイルが選択されていません</p></div>
                    )}
                  </Stack>

                  <div style={{ width: '100%' }}>
                    <DataGrid
                      className='DataGrid'
                      columns={columns}
                      rows={rows}
                      autoHeight
                      disableSelectionOnClick
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      pagination
                      localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                    />
                  </div>

                  <Dialog
                    fullWidth
                    maxWidth="xl"
                    open={alliesOpen}
                    onClose={alliesCancelButton}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      品目同類一覧
                    </DialogTitle>
                    <DialogContent style={{ height: "100%", minHeight: "300px" }}>

                      <Button style={{ width: "200px" }} onClick={setAlliesEmpty}>新規追加</Button>

                      <div style={{ width: "100%" }}>
                        <DataGrid
                          className="DataGrid"
                          columns={alliesColumns}
                          rows={alliesRows}
                          autoHeight
                          onEditRowsModelChange={editAlliesChange}
                          disableSelectionOnClick
                          localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                        />
                      </div>

                    </DialogContent>
                    <DialogActions>
                      <Button onClick={alliesCancelButton}>キャンセル</Button>
                      <Button onClick={alliesDecisionButton}>保存</Button>
                    </DialogActions>
                  </Dialog>

                  <Dialog
                    fullWidth
                    maxWidth="xl"
                    open={analogyOpen}
                    onClose={analogyCancelButton}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      品目類推一覧
                    </DialogTitle>
                    <DialogContent style={{ height: "100%", minHeight: "300px" }}>

                      <Button style={{ width: "200px" }} onClick={setAnalogyEmpty}>新規追加</Button>

                      <div style={{ width: "100%" }}>
                        <DataGrid
                          className="DataGrid"
                          columns={analogyColumns}
                          rows={analogyRows}
                          autoHeight
                          onEditRowsModelChange={editAnalogyChange}
                          disableSelectionOnClick
                          localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                        />
                      </div>

                    </DialogContent>
                    <DialogActions>
                      <Button onClick={analogyCancelButton}>キャンセル</Button>
                      <Button onClick={analogyDecisionButton}>保存</Button>
                    </DialogActions>
                  </Dialog>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default G0141AnimalQuarantineList;